/**
 * Detects whether user has local vault data worth preserving.
 *
 * In Bóveda (zero-knowledge) "local data" means: account root
 * (`vault_account`, keyed by `user_id`) or an item in an owned vault
 * (`vault_item` belongs to `vault.owner_user_id`). Governs the dialog
 * "preserve local data?" when migrating from visitor to real account and
 * "delete local data" button in profile.
 *
 * DOES NOT query `ps_crud`: that upload queue holds device settings row
 * seeded on startup for each visitor (`user`/`themes` tables, not data to migrate)
 * and would trigger dialog spuriously.
 */
export const getHasLocalDataQuery = (userId: string) => {
  return {
    sql: `
    SELECT CASE
      WHEN EXISTS (SELECT id FROM vault_account WHERE user_id = ? LIMIT 1) THEN 1
      WHEN EXISTS (
        SELECT vault_item.id FROM vault_item
        JOIN vault ON vault.id = vault_item.vault_id
        WHERE vault.owner_user_id = ? LIMIT 1
      ) THEN 1
      ELSE 0
    END as hasData
  `,
    parameters: [userId, userId],
  };
};
